module.exports = __webpack_public_path__ + "static/media/ReviewIcon.5746cd64.png";